import Icon from '../../../components/AppIcon';
import { CustomerInfo } from '../types';

interface CustomerInfoCardProps {
  customerInfo: CustomerInfo;
}

const CustomerInfoCard = ({ customerInfo }: CustomerInfoCardProps) => {
  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center gap-3 mb-4">
        <div className="p-2 bg-primary/10 rounded-lg">
          <Icon name="User" size={20} className="text-primary" />
        </div>
        <h2 className="text-lg font-semibold text-text-primary">Customer Information</h2>
      </div>

      <div className="space-y-4">
        {/* Company Name Section */}
        <div className="border-b border-border pb-3">
          <div className="flex items-start gap-3">
            <Icon name="Building2" size={16} className="text-text-secondary mt-1 flex-shrink-0" />
            <div className="flex-1">
              <div className="text-sm font-medium text-text-secondary mb-1">Company Name</div>
              <div className="font-semibold text-text-primary">
                {customerInfo?.company || customerInfo?.name || 'N/A'}
              </div>
            </div>
          </div>
        </div>

        {/* Company Contact Section */}
        <div className="border-b border-border pb-3">
          <div className="flex items-start gap-3">
            <Icon name="User" size={16} className="text-text-secondary mt-1 flex-shrink-0" />
            <div className="flex-1">
              <div className="text-sm font-medium text-text-secondary mb-1">Company Contact</div>
              <div className="font-semibold text-text-primary mb-2">
                {customerInfo?.name || 'N/A'}
              </div>
              
              {/* Contact Details */}
              <div className="space-y-2 mt-3">
                {customerInfo?.email && (
                  <div className="flex items-center gap-2 text-sm">
                    <Icon name="Mail" size={14} className="text-text-secondary flex-shrink-0" />
                    <span className="text-text-primary">{customerInfo.email}</span>
                  </div>
                )}

                {customerInfo?.phone && (
                  <div className="flex items-center gap-2 text-sm">
                    <Icon name="Phone" size={14} className="text-text-secondary flex-shrink-0" />
                    <span className="text-text-primary">{customerInfo.phone}</span>
                  </div>
                )}

                {customerInfo?.address && (
                  <div className="flex items-start gap-2 text-sm">
                    <Icon name="MapPin" size={14} className="text-text-secondary mt-0.5 flex-shrink-0" />
                    <span className="text-text-primary whitespace-pre-line">{customerInfo.address}</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerInfoCard;